import React, { memo } from 'react'

import { func, shape } from 'prop-types'

import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import { imageShape } from 'Pods/ThreeDStudio/Shared/ImageModal/imageShape'

import { NOOP } from 'Utils/stableDefaults'

import Comments from './Components/Comments/Comments'
import Creator from './Components/Creator/Creator'
import Prompt from './Components/Prompt/Prompt'
import SimilarImages from './Components/SimilarImages/SimilarImages'
import useSimilarImages from './useSimilarImages'

// Similar images are a signed-in feature: the endpoint refuses anonymous requests, so a
// signed-out viewer gets no request and no section.
//
// The full image payload always carries a user key (null for a run with no author). A clicked
// similar image stands in without one until that payload loads, so a missing key means the
// author is still loading.
function Details({ image, onSelect = NOOP }) {
  const isLoggedIn = !!usePageConfig()?.isCurrentUser
  const similarImages = useSimilarImages(isLoggedIn ? image.assetId : null, image.slug)

  return (
    <div className="image-gallery-modal__details">
      <div className="image-gallery-modal__details-header" />
      <div className="image-gallery-modal__summary">
        <Creator user={image.user} createdAt={image.createdAt} isLoading={image.user === undefined} />
        <Prompt text={image.prompt} />
      </div>
      {image.slug && <Comments slug={image.slug} />}
      {isLoggedIn && <SimilarImages images={similarImages} onSelect={onSelect} />}
    </div>
  )
}

Details.propTypes = {
  image: shape(imageShape).isRequired,
  onSelect: func,
}

export default memo(Details)
